module.exports = __webpack_public_path__ + "img/jinggao-L@3x.723b68ac.svg";